import { render, staticRenderFns } from "./PlacementsForm.vue?vue&type=template&id=1427351f&"
import script from "./PlacementsForm.vue?vue&type=script&lang=js&"
export * from "./PlacementsForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PlacementsForm.vue?vue&type=style&index=1&id=1427351f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports